import { computed, ref, onUnmounted } from 'vue'

const TOAST_LIMIT = 5 // TODO: move this as prop
const TOAST_REMOVE_DELAY = 5000

const ACTION_TYPES = {
  ADD_TOAST: 'ADD_TOAST',
  UPDATE_TOAST: 'UPDATE_TOAST',
  DISMISS_TOAST: 'DISMISS_TOAST',
  REMOVE_TOAST: 'REMOVE_TOAST',
}

let count = 0

function genId () {
  count = (count + 1) % Number.MAX_VALUE
  return count.toString()
}

const toastTimeouts = new Map()

function addToRemoveQueue (toastId) {
  if (toastTimeouts.has(toastId)) return

  const timeout = setTimeout(() => {
    toastTimeouts.delete(toastId)
    handleToastAction({
      type: ACTION_TYPES.REMOVE_TOAST,
      toast: {
        toastId,
      },
    })
  }, TOAST_REMOVE_DELAY)

  toastTimeouts.set(toastId, timeout)
}

const state = ref({
  toasts: [],
})

function addToast (toast) {
  state.value.toasts = [toast, ...state.value.toasts].slice(0, TOAST_LIMIT)
}

function updateToast (toast) {
  state.value.toasts = state.value.toasts.map((t) =>
    t.id === toast.id ? { ...t, ...toast } : t,
  )
}

function dismissToast ({ toastId }) {
  if (toastId) {
    addToRemoveQueue(toastId)
  } else {
    state.value.toasts.forEach((toast) => {
      addToRemoveQueue(toast.id)
    })
  }

  state.value.toasts = state.value.toasts.map((t) =>
    t.id === toastId || toastId === undefined
      ? { ...t, open: false }
      : t,
  )
}

function removeToast ({ toastId }) {
  if (toastId === undefined) state.value.toasts = []
  else {
    state.value.toasts = state.value.toasts.filter(
      (t) => t.id !== toastId,
    )
  }
}

function handleToastAction ({ type, toast }) {
  const actions = {
    [ACTION_TYPES.ADD_TOAST]: addToast,
    [ACTION_TYPES.UPDATE_TOAST]: updateToast,
    [ACTION_TYPES.DISMISS_TOAST]: dismissToast,
    [ACTION_TYPES.REMOVE_TOAST]: removeToast,
  }

  actions[type] ? actions[type](toast) : console.error(`Toast: action '${type}' is not recognized`)
}

function useToast () {
  onUnmounted(() => {
    removeToast({ toastId: undefined })
  })

  return {
    toasts: computed(() => state.value.toasts),
    toast,
    dismiss: (toastId) =>
      handleToastAction({
        type: ACTION_TYPES.DISMISS_TOAST,
        toast: { toastId },
      }),
  }
}

function toast (props) {
  const id = genId()

  const update = (props) =>
    handleToastAction({
      type: ACTION_TYPES.UPDATE_TOAST,
      toast: { ...props, id },
    })

  const dismiss = () => {
    handleToastAction({
      type: ACTION_TYPES.DISMISS_TOAST,
      toast: { toastId: id },
    })
  }

  handleToastAction({
    type: ACTION_TYPES.ADD_TOAST,
    toast: {
      ...props,
      dismissable: props.dismissable ?? true,
      id,
      open: true,
      onOpenChange: (open) => {
        if (!open) dismiss()
      },
    },
  })

  return {
    id,
    dismiss,
    update,
  }
}

export { toast, useToast }
